import { render, staticRenderFns } from "./IconBtn.vue?vue&type=template&id=e8bb1e8e"
import script from "./IconBtn.vue?vue&type=script&lang=js"
export * from "./IconBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports